import { Component, OnDestroy } from '@angular/core';
import { NavigatorService } from '../shared/services/navigator/navigator.service';
import { Observable, Subject, takeUntil } from 'rxjs';
import { ShellService } from './shell.service';

@Component({
  selector: 'app-shell',
  templateUrl: './shell.component.html',
})
export class ShellComponent implements OnDestroy {
  isQuestion!: boolean;
  isChat!: boolean;
  isApp: boolean = this.navigator.isApp;
  unsubscribe$: Subject<void> = new Subject();
  isSearchDisabled!: boolean;
  equisLoadingSize: any = 'large';
  isLoading$: Observable<boolean> = this.shellService.isLoading$;

  constructor(
    private navigator: NavigatorService,
    private shellService: ShellService,
  ) {
    this.navigator.isQuestion$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(res => (this.isQuestion = res));
    this.navigator.isChat$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(res => (this.isChat = res));
    this.isSearchDisabled = this.navigator.isSearchDisabled;
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
